// import apiService from "./api/apiServices";

import apiService from "./api/apiService.js";
import authService from "./authService.js";
import billingService from "./billingService.js";
import localStorageService from "./localStorageService.js";
import logService from "./logService.js";
import sessionStorageService from "./sessionStorageService.js";
import utilityService from "./utilityService.js";
import workOrdersService from "./workOrdersService.js";

/**
 * This is just a container of all the available services in the app
 */
//------------------------------------------------
const Services = {
  api: apiService,
  auth: authService,
  billing: billingService,
  localStorage: localStorageService,
  log: logService,
  sessionStorage: sessionStorageService,
  utility: utilityService,
  workOrders: workOrdersService,
};

export default Services;
//------------------------------------------------
